import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance", "size", "as", "style", "css"];
import React from "react";
import { getAppearance } from "../Button/logic";
import { BaseLinkButton } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var LinkButton = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var appearance = _ref.appearance,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    as = _ref.as,
    style = _ref.style,
    css = _ref.css,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _getAppearance = getAppearance(appearance),
    color = _getAppearance.color,
    variant = _getAppearance.variant;
  return /*#__PURE__*/_jsx(BaseLinkButton, _extends({
    ref: forwardedRef,
    color: color,
    variant: variant,
    size: size
  }, restProps));
});
LinkButton.displayName = "LinkButton";
export default LinkButton;